import { api } from '../configs/axiosConfigs';

export const getPropertyListSortPropertyJoins = async (propertyId: string) => {
  return await api.get(`/properties/${propertyId}/list-sort-property-joins`);
};
